<template>
    <div class="brand-list">
        <div class="brand-item" v-for="(item) in list" @click="skipClassify(item)" :key="item.id">
            <img :src="item.banner" alt="">
            <van-cell :title="item.name"/>
        </div>	
    </div>
</template>
<script>
export default {
    props:{
        list:{
            type:Array,
            default:[]
        }
    },
    data(){
        return{

        }
    },
    methods:{
		//跳转分类
		skipClassify(item){
			this.$router.push({
				path:'/instrument/brand',
				query:{
					id:item.id,
					brandImg:item.banner
				}
			})
		}
    }
}
</script>
<style lang="scss" scoped>
    .brand-list{
		.brand-item{
            border-bottom:1px solid #ddd;
			height:68px;
			align-items:center;
			padding-left: 12px;
			@include flex(row);
			font-size: 14px;
			color: #090909;
			letter-spacing: 0.49px;
			img{
				height:40px;
				border-radius:50%;
			}
		}
    }
</style>


// WEBPACK FOOTER //
// src/pages/Instrument/Components/Brand.vue